import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileStatisticsState } from '../reducers/profile-statistics.reducer';
import { PROFILE_STATISTICS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ProfileStatisticsState>(PROFILE_STATISTICS_FEATURE_KEY);

export const selectProfileStatistics = createSelector(selectState, (state) => state.data);
export const selectProfileStatisticsLoading = createSelector(selectState, (state) => state.loading);
export const selectProfileStatisticsLoaded = createSelector(selectState, (state) => state.loaded);
